import type { RichEditorPreset } from '@odo/shared-ui';
import { PLAIN_TAIL, toDoc } from './docBuilders.ts';
import { filled, type VcaNoteFields } from './noteFields.ts';

export function refinementV2NotesPreset(fields: VcaNoteFields): RichEditorPreset {
    const f = filled(fields);
    return {
        id: 'refinement-template-v2',
        label: 'Refinement template v2',
        description: 'Doctor, patient and current aligner filled in; edit the rest.',
        doc: toDoc([
            [[`Good Morning/Afternoon Dr. ${f.doctor},`]],
            [
                [
                    `PX ${f.patientFirstName} is currently at aligner ${f.aligner} of [#] active + [#] passive and is ready for a refinement evaluation appointment. This is to inform you of the patient’s next steps. Abby/Treatment Coordinator will be reaching out to ${f.patientFirstName} shortly to schedule them. Please be on the look out for an upcoming appointment appearing on the schedule.`
                ],
                [
                    'Please instruct the patient to remain in the aligner they were wearing at the time of the refinement scan and not advance to the next tray while waiting for the new set to arrive.'
                ]
            ],
            [
                ['See Dr. John/Baker’s instructions below.'],
                [{ bold: 'Ortho Instructions:' }, PLAIN_TAIL]
            ],
            [
                [
                    { bold: 'Patient Feedback:' },
                    ' Please provide subjective feedback in the dashboard from the patient, if there is none please enter N/A. This is very helpful for our ortho team as we are refining the case!'
                ],
                ['For example: "Patient states, #12 is hitting heavy."']
            ],
            [['Thank you!']]
        ])
    };
}
